import { Config } from '../../video-data/config';
import { DynamicAnimationConfiguration } from '../../libs/DynamicAnimationConfiguration';
import type { BaseAsset } from '../asset/BaseAsset';

export class MorphEngine {
    #owner: BaseAsset;
    #animations: DynamicAnimationConfiguration[] = [];

    constructor(owner: BaseAsset) {
        this.#owner = owner;
    }

    get animations(): readonly DynamicAnimationConfiguration[] {
        return this.#animations;
    }

    get hasAnimations(): boolean {
        return this.#animations.length > 0;
    }

    addAnimation(): DynamicAnimationConfiguration {
        const animationConfigurator = new DynamicAnimationConfiguration({
            parent: this.#owner,
        });
        this.#animations = [...this.#animations, animationConfigurator];
        this.#owner.requiresRedraw = true;
        return animationConfigurator;
    }

    clearAnimations(): void {
        this.#animations = [];
        this.#owner.requiresRedraw = true;
    }

    update(): void {
        this.#animations.forEach((configurator) => {
            configurator.anchorsToRemove = this.#owner._animationAnchorsToRemove;
            if (!configurator.enabled) {
                return;
            }
            const animationCurveConfig = configurator.buildConfig();

            const startPoint = (() => {
                const duration =
                    this.#owner._morphParameters?.duration ?? Config.DEFAULT_MORPH_DURATION;
                const containerDuration = Math.max(this.#owner.container.duration, 1.0);
                return Math.max(0, 1 - duration / containerDuration);
            })();

            animationCurveConfig.initPercentageOffset = startPoint;
            animationCurveConfig.mode = 'single';
            animationCurveConfig.drivenObjects = [this.#owner];
            this.#owner.animationManager.add(animationCurveConfig);
        });
    }

    setAutoUpdate(value: boolean): void {
        this.#animations.forEach((configurator) => {
            configurator.autoUpdate = value;
        });
    }
}
